"use client"

import { useEffect } from "react"

/**
 * Hides the Chatwoot chat launcher on the /start and /login pages (this component
 * is mounted in the (auth) route group's layout, which wraps both). Same body-class
 * + CSS pattern as checkout's "checkout-hide-chat" (see globals.css).
 */
export default function AuthHideChat() {
  useEffect(() => {
    document.body.classList.add("auth-hide-chat")
    return () => document.body.classList.remove("auth-hide-chat")
  }, [])

  return null
}
